import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, CloseIcon, Tooltip } from '@routific/hive/v5';
import { observer } from 'mobx-react';
import { VisitDtoModelType } from '../../../store/mst/models';
import OrderActionsButton from './OrderActionsButton';

interface Props {
  visit: VisitDtoModelType;
  handleClose: () => void;
  allowEdit?: boolean;
  allowDelete?: boolean;
  allowCreateCustomers?: boolean;
}

const OrderDetailsPanelHeader: React.FC<Props> = ({
  visit, handleClose, allowEdit = false, allowDelete = false, allowCreateCustomers = false,
}) => {
  const { t } = useTranslation('components');
  const closeLabel = t('unscheduledVisits.header.close');

  return (
    <>
      <OrderActionsButton
        visit={visit}
        allowEdit={allowEdit}
        allowDelete={allowDelete}
        allowCreateCustomers={allowCreateCustomers}
      />
      <Tooltip title={closeLabel}>
        <Button
          hierarchy="tertiary"
          buttonType="icon-only"
          size="md"
          icon={<CloseIcon size="md" />}
          onClick={() => handleClose()}
          aria-label={closeLabel}
          data-cy="close-order-details-btn"
          data-testid="close-order-details-btn"
        />
      </Tooltip>
    </>
  );
};

export default observer(OrderDetailsPanelHeader);
